import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { brl, limitText } from "@/lib/api";
import { moduleIcon, planModuleItems } from "@/lib/modules";

export const planLimits = (p) => [limitText(p.max_users, "usuário", "usuários"), limitText(p.max_products, "produto", "produtos"),
  limitText(p.max_orders, "pedido por mês", "pedidos por mês"), limitText(p.max_stores, "loja", "lojas"), p.support && `Suporte: ${p.support}`].filter(Boolean);

export function PlanDetailsDialog({ plan, catalog, onClose }) {
  const items = planModuleItems(plan.modules, catalog);
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="landing-plan-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Plano {plan.name}</DialogTitle>
          {plan.description && <DialogDescription>{plan.description}</DialogDescription>}
        </DialogHeader>
        <p className="flex flex-wrap items-baseline gap-x-2"><b className="font-display text-3xl">{brl(plan.price)}</b><span className="text-muted-foreground">/mês</span>
          {plan.price_yearly > 0 && <span className="text-sm text-muted-foreground">ou {brl(plan.price_yearly)}/ano</span>}</p>
        <div className="flex flex-wrap gap-2">{planLimits(plan).map((l) => <span key={l} className="rounded-full border px-3 py-1 text-xs">{l}</span>)}</div>
        <p className="eyebrow" data-testid="landing-plan-dialog-count">{items.length} módulos incluídos</p>
        <div className="grid gap-2 sm:grid-cols-2" data-testid="landing-plan-dialog-modules">
          {items.map((m) => {
            const Icon = moduleIcon(m.id);
            return (
              <div key={m.id} className="flex items-start gap-3 rounded-xl border p-3" data-testid={`landing-plan-module-${m.id}`}>
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-primary/15 text-primary"><Icon className="h-4 w-4" /></span>
                <span className="min-w-0"><b className="block text-sm font-semibold">{m.label}</b>{m.description && <span className="text-xs text-muted-foreground">{m.description}</span>}</span>
              </div>
            );
          })}
        </div>
        <DialogFooter>
          <Button asChild data-testid="landing-plan-dialog-signup-btn"><Link to="/cadastro">Começar teste grátis<ArrowRight className="ml-1 h-4 w-4" /></Link></Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
